import * as api from "services/api";
import { getErrors } from "helpers/error";

export const GET_CONTRACT_DETAIL = "[CONTRACT_DETAIL] GET_CONTRACT_DETAIL";
export const GET_CONTRACT_DETAIL_ERROR =
	"[CONTRACT_DETAIL] GET_CONTRACT_DETAIL_ERROR";
export const GET_CONTRACT_DETAIL_SUCCESS =
	"[CONTRACT_DETAIL] GET_CONTRACT_DETAIL_SUCCESS";

export const DELETE_CONTRACT = "[CONTRACT DETAIL] DELETE_CONTRACT";
export const DELETE_CONTRACT_ERROR = "[CONTRACT DETAIL] DELETE_CONTRACT_ERROR";
export const DELETE_CONTRACT_SUCCESS =
	"[CONTRACT DETAIL] DELETE_CONTRACT_SUCCESS";

export const GET_CONTRACT_COLLECTION =
	"[CONTRACT_COLLEGET_CONTRACT_COLLECTION] GET_CONTRACT_COLLECTION";
export const GET_CONTRACT_COLLECTION_ERROR =
	"[CONTRACT_COLLEGET_CONTRACT_COLLECTION] GET_CONTRACT_COLLECTION_ERROR";
export const GET_CONTRACT_COLLECTION_SUCCESS =
	"[CONTRACT_COLLEGET_CONTRACT_COLLECTION] GET_CONTRACT_COLLECTION_SUCCESS";

export const SET_VALUE = "[CONTRACT_DETAIL] SET_VALUE";
export const CLEAR_VALUES = "[CONTRACT_DETAIL] CLEAR_VALUES";

export function setValue(payload) {
	return dispatch => {
		dispatch({ type: SET_VALUE, payload });
	};
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getContractRegularById(id, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_CONTRACT_DETAIL
		});

		try {
			const { login } = getState();

			let response = await api.sendGet(`/contracts/${id}`, {
				Authorization: "Bearer " + login.token
			});

			let result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_CONTRACT_DETAIL_SUCCESS,
					payload: result.model
				});
				callback && callback(null, result.model);
			} else {
				dispatch({
					type: GET_CONTRACT_DETAIL_ERROR,
					payload: getErrors(result.errors)
				});
			}
		} catch (error) {
			return dispatch({
				type: GET_CONTRACT_DETAIL_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function deleteContract(id, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: DELETE_CONTRACT
		});

		try {
			const { login } = getState();

			let response = await api.sendDelete(`/contracts/${id}`, {
				Authorization: "Bearer " + login.token
			});

			let result = await response.json();

			if (result.isValid) {
				dispatch({
					type: DELETE_CONTRACT_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				dispatch({
					type: DELETE_CONTRACT_ERROR,
					payload: getErrors(result.errors)
				});
			}
		} catch (error) {
			return dispatch({
				type: DELETE_CONTRACT_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function getContractCollectionById(id, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_CONTRACT_COLLECTION
		});

		try {
			const { login } = getState();

			let response = await api.sendGet(`/contracts/collection/${id}`, {
				Authorization: "Bearer " + login.token
			});

			let result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_CONTRACT_COLLECTION_SUCCESS,
					payload: result.model
				});
				callback && callback(null, result.model);
			} else {
				dispatch({
					type: GET_CONTRACT_COLLECTION_ERROR,
					payload: getErrors(result.errors)
				});
			}
		} catch (error) {
			return dispatch({
				type: GET_CONTRACT_COLLECTION_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
